/*
 报表管理--设备指标报表--设备完好率--设备完好率趋势--图表
 */
import React, { Component } from "react";
import Echarts from "echarts";
import { Spin } from "antd";
import moment from "moment";
import { twoMonthStation } from "../../../fetch/fetchApi";
import fetchHandler from "../../../fetch/fetchHandler";

class StubIntactDetailInner extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      seeframeWorkVisible: false, // 状态日志模态框展示标识
      showSpinning: false, // 图表加载标识
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
  }

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return `${day}天${hour}时${minute}分`;
    } else if (hour > 0) {
      return `${hour}时${minute}分`;
    } else if (minute > 0) {
      return `${minute}分`;
    } else {
      return `${second}秒`;
    }
  }

  componentDidMount() {}

  // 页面加载完成执行
  componentWillMount() {
    this.setState(
      {
        stubId: this.props.stubId, // 设置设备编号
        showSpinning: true, // 图表加载 loading展示
      },
      () => {
        this.queryStubOperationModeInfo(); // 获取数据，加载图表
      },
    );
  }

  // 调用接口获取数据
  queryStubOperationModeInfo() {
    fetchHandler(twoMonthStation, {
      stubId: this.state.stubId,
    }).then((res) => {
      if (res) {
        this.setState(
          {
            stubData: res.data, // 图表数据
            showSpinning: false, // 图表加载，loading 关闭
          },
          () => {
            this.stubIntactChart(); // 图表设置
          },
        );
      }
    });
  }

  /**
   * 完好率按日期图表展示
   */
  stubIntactChart() {
    const arryData = [...this.state.stubData];

    // 设置X轴
    const xAxisData = arryData.map((item) => {
      return moment(item.date).format("MM.DD");
    });

    // 设置完好率数据
    const intactData = arryData.map((item) => {
      return {
        value: item.intactRate,
        info: {
          value: this.handleSecord(
            parseInt(item.totalOperationDuration
              - item.totalErrorDuration - item.totalOfflineDuration),
          ),
          name: "完好时长",
        },
      };
    });

    // 设置离线率数据
    const offlineData = arryData.map((item) => {
      return {
        value: item.offlineRate,
        info: {
          value: this.handleSecord(
            parseInt(item.totalOfflineDuration),
          ),
          name: "离线时长",
        },
      };
    });

    // 设置故障率数据
    const errorData = arryData.map((item) => {
      return {
        value: item.errorRate,
        info: {
          value: this.handleSecord(
            parseInt(item.totalErrorDuration),
          ),
          name: "故障时长",
        },
      };
    });
    // 设置可用率数据
    const availableData = arryData.map((item) => {
      return {
        value: item.availableRate,
        info: {
          value: this.handleSecord(
            parseInt(item.totalAvailableDuration),
          ),
          name: "可用时长",
        },
      };
    });

    // 设置设备完好时长数据
    const stubNumData1 = arryData.map((item) => {
      return item.totalOperationDuration
      - item.totalErrorDuration - item.totalOfflineDuration;
    });
    // 设置设备故障时长数据
    const stubNumData2 = arryData.map((item) => {
      return item.totalErrorDuration;
    });
    // 设置离线时长数据
    const stubNumData3 = arryData.map((item) => {
      return item.totalOfflineDuration;
    });
    // 设置维护时长数据
    const stubNumData4 = arryData.map((item) => {
      return {
        value: item.totalAvailableDuration - item.totalOfflineDuration,
        info: {
          value: item.totalOperationDuration,
          name: "运营时长",
        },
      };
    });

    const myChart = Echarts.init(document.getElementById(`chart-detail${this.state.chartId}`));
    const option = {
      color: [
        "#e5323e",
        "#0000CD",
        "#6B8E23",
        "#FFD700",
        "#73D13D",
        "#FFBE56",
        "#729399",
        "#C0C0C0",
      ],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        formatter: (param) => {
          let toolInfo = "";

          const names = param.map((v) => v.seriesName);
          const index1 = names.findIndex((v) => v === "维护时长");
          const includesName1 = names.includes("维护时长");

          if (includesName1) {
            toolInfo = `运营时长: ${this.handleSecord(parseInt(param[index1].data.info.value))},维护时长: ${this.handleSecord(parseInt(param[index1].value))}`;
          }

          param.map((item) => {
            if (item.seriesName !== "维护时长" && item.seriesName !== "完好时长" && item.seriesName !== "离线时长" && item.seriesName !== "故障时长") {
              const msg = `
                                       <div> ${item.data.info.name}:${item.data.info.value}, ${item.seriesName}:${item.value}%</div>
                                      `;
              toolInfo += msg;
            }
            return true;
          });
          return toolInfo;
        },
      },
      legend: {
        selectedMode: false,
        data: [
          "完好率",
          "离线率",
          "故障率",
          "可用率",
          "完好时长",
          "故障时长",
          "离线时长",
          "维护时长",
        ],
      },
      grid: {
        left: "50px",
        right: "70px",
      },
      dataZoom: {
        // type: 'inside',
        showDetail: false,
        startValue: 0,
        endValue: 29,
        // maxValueSpan:11,
        handleIcon:
          "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
        handleSize: "40%",
        handleStyle: {
          color: "#fff",
          shadowBlur: 3,
          shadowColor: "rgba(0, 0, 0, 0.6)",
          shadowOffsetX: 2,
          shadowOffsetY: 2,
        },
      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          name: "",
          // x轴文字倾斜
          axisLabel: {
            interval: 0,
            margin: 10,
            rotate: 35,
            textStyle: {
              fontWeight: "bolder",
              color: "#000000",
            },
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: "",
          min: 0,
          max: 100,
          interval: 10,
          axisLabel: {
            formatter: "{value} %",
          },
        },
        {
          type: "value",
          show: false,
          name: "",
          interval: 8640,
          min: 0,
          max: 86400,
          axisLabel: {
            formatter: "{value}",
            color: "#fff",
          },
        },
      ],
      series: [
        {
          name: "完好率",
          type: "line",
          yAxisIndex: 0,
          z: 4,
          data: intactData,
        },
        {
          name: "离线率",
          type: "line",
          yAxisIndex: 0,
          z: 4,
          data: offlineData,
        },
        {
          name: "故障率",
          type: "line",
          yAxisIndex: 0,
          z: 4,
          data: errorData,
        },
        {
          name: "可用率",
          type: "line",
          yAxisIndex: 0,
          z: 4,
          data: availableData,
        },
        {
          stack: "1",
          name: "完好时长",
          type: "bar",
          barWidth: 30,
          yAxisIndex: 1,
          barGap: "-100%",
          z: 3,
          data: stubNumData1,
        },
        {
          stack: "1",
          name: "故障时长",
          type: "bar",
          barWidth: 30,
          yAxisIndex: 1,
          barGap: "-100%",
          z: 2,
          data: stubNumData2,
        },
        {
          stack: "1",
          name: "离线时长",
          type: "bar",
          barWidth: 30,
          yAxisIndex: 1,
          barGap: "-100%",
          z: 1,
          data: stubNumData3,
        },
        {
          stack: "1",
          name: "维护时长",
          type: "bar",
          barWidth: 30,
          yAxisIndex: 1,
          barGap: "-100%",
          z: 1,
          data: stubNumData4,
        },
      ],
      contentToOption: function () {
        // 数据视图刷新的方法
        // this.stubIntactChart();
      },
    };
    myChart.clear();
    myChart.setOption(option);
    // 图例选中状态事件
    myChart.on("legendselectchanged", () => {});

    // 图表中点击执行
    myChart.on("click", (obj) => {
      console.log(obj);
      this.props.changeDay(xAxisData[obj.dataIndex]);
    });
  }

  render() {
    const Width = document.body.clientWidth - 245;
    return (
      <div className='analysis-content-3'>
        <Spin tip='加载中...' spinning={this.state.showSpinning}>
          <div style={{ width: Width, height: 400 }} id={`chart-detail${this.state.chartId}`}></div>
        </Spin>
      </div>
    );
  }
}

export default StubIntactDetailInner;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/stubIntactRate/stubIntactDetailInner.js